const useGetFileExtension = (downloadUrl) => {
  const splitData = downloadUrl.split('.')
  return splitData[splitData.length - 1].toLowerCase()
}

export default useGetFileExtension
